import React from "react";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import apiCalls from "../../../redux/actions/ApiCalls";
import PropTypes from "prop-types";

function ButtonLoading(props) {
  const style = {};
  return props.activeApis[apiCalls[props.api]] ? <Spinner animation="grow" style={style} /> : <></>;
}

ButtonLoading.propTypes = { api: PropTypes.string.isRequired };

function mapStateToProps(state, ownProps) {
  return {
    activeApis: state.activeApis
  };
}

export default connect(mapStateToProps)(ButtonLoading);
